import React, { useMemo } from 'react';
import styles from './index.module.scss';

import Flex from '../Flex';
import BreadcrumbItem from './BreadcrumbItem';
import BreadcrumbSeparator from './BreadcrumbSeparator';

export default function Breadcrumbs({ children = null }) {
  const content = useMemo(() => {
    const validChildren = React.Children.toArray(children).filter((child) => {
      return child.type === BreadcrumbItem;
    });
    return validChildren.reduce((acc, child, index) => {
      const isFirst = index === 0;
      const isLast = index === validChildren.length - 1;
      if (!isFirst) acc.push(<BreadcrumbSeparator key={index} />);

      const tone = isLast ? 'default' : 'muted';
      acc.push(React.cloneElement(child, { tone }));
      return acc;
    }, []);
  }, [children]);

  return (
    <Flex align="center" gap={8} className={styles.container}>
      {content}
    </Flex>
  );
}

Breadcrumbs.Item = BreadcrumbItem;
